import { Routes } from '@angular/router';
import {
  DEVICE_ROLES,
  GATEWAY_ROLES,
  PLATFORM_ADMIN_ROLES,
  PLATFORM_ROLES,
  SITE_ROLES,
  USER_ROLES,
} from '@wheere-front/inside-shared-data-access';
import {
  authenticationGuard,
  bounceOrgToIntegratorApp,
  permissionGuard,
  userHasAnyRole,
} from '@wheere-front/shared-auth';
import { LEGACY_REDIRECTS } from './legacy-redirects';

export const routes: Routes = [
  {
    // Root wrapper — runs auth first (kicks off Keycloak login if needed),
    // then bounces any ORG_* user away to integrator.<env>.wheere.tech so
    // only PLATFORM_* (Wheere staff) ever render the inside admin shell.
    // ORG_CUSTOMER then chains on to customer.<env>.wheere.tech via the
    // bounce guard on the integrator app root.
    path: '',
    canActivate: [authenticationGuard(), bounceOrgToIntegratorApp()],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      // Anciennes URL déplacées par la navigation à 5 entrées : avant les routes de section.
      ...LEGACY_REDIRECTS,
      {
        path: 'home',
        loadComponent: () => import('./home.component'),
      },
      {
        // Administration › Journal d'audit (ex-Users › Audit). Mêmes rôles que l'ancienne page.
        path: 'admin/journal',
        loadChildren: () => import('@wheere-front/inside-users').then(m => m.ADMIN_JOURNAL_ROUTES),
        canActivate: [userHasAnyRole(PLATFORM_ROLES)],
      },
      {
        // Administration › Équipements de test : création de faux trackers / gateways (ex-boutons
        // des listes). PLATFORM_ADMIN seul, comme `platform:fake` des endpoints serveur.
        path: 'admin/equipements-test',
        loadChildren: () => import('@wheere-front/inside-management').then(m => m.TEST_EQUIPMENT_ROUTES),
        canActivate: [userHasAnyRole(PLATFORM_ADMIN_ROLES)],
      },
      {
        path: 'devices',
        loadChildren: () => import('@wheere-front/inside-devices').then(m => m.DEVICES_ROUTES),
        canActivate: [userHasAnyRole(DEVICE_ROLES)],
      },
      {
        path: 'gateways',
        loadChildren: () => import('@wheere-front/inside-gateways').then(m => m.GATEWAYS_ROUTES),
        canActivate: [userHasAnyRole(GATEWAY_ROLES)],
      },
      {
        path: 'sites/admin',
        loadChildren: () => import('@wheere-front/inside-site-admin').then(m => m.SITE_ADMIN_ROUTES),
        canActivate: [permissionGuard(['site-template:admin'])],
      },
      {
        path: 'sites',
        loadChildren: () => import('@wheere-front/inside-sites').then(m => m.SITES_ROUTES),
        canActivate: [userHasAnyRole(SITE_ROLES)],
      },
      {
        path: 'users',
        loadChildren: () => import('@wheere-front/inside-users').then(m => m.USERS_ROUTES),
        canActivate: [userHasAnyRole(USER_ROLES)],
      },
      {
        // Administration › Attributions : page d'écriture (attribution d'org), PLATFORM_ADMIN seul.
        path: 'manage',
        loadChildren: () => import('@wheere-front/inside-management').then(m => m.MANAGEMENT_ROUTES),
        canActivate: [userHasAnyRole(PLATFORM_ADMIN_ROLES)],
      },
      {
        path: 'tools',
        loadChildren: () => import('@wheere-front/inside-tools').then(m => m.TOOLS_ROUTES),
        canActivate: [userHasAnyRole(SITE_ROLES)],
      },
      {
        // Centre de notifications (flux 18) : historique et réglages « Ce que je reçois ».
        path: 'notifications',
        loadComponent: () => import('@wheere-front/inside-shared-feature').then(m => m.NotificationsHistoryComponent),
      },
      {
        path: 'notifications/reglages',
        loadComponent: () =>
          import('@wheere-front/inside-shared-feature').then(m => m.NotificationPreferencesComponent),
      },
      {
        path: 'account',
        loadComponent: () => import('@wheere-front/inside-shared-feature').then(m => m.AccountComponent),
      },
      {
        path: 'forbidden',
        loadComponent: () => import('@wheere-front/shared-feature').then(m => m.ForbiddenComponent),
      },
      {
        path: '**',
        loadComponent: () => import('@wheere-front/shared-feature').then(m => m.NotFoundComponent),
      },
    ],
  },
];
